import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CButton,
	CModal,
	CModalBody,
	CModalFooter,
	CModalHeader,
	CModalTitle,
	CCloseButton,
	CRow, CCol,
	CForm, CFormInput, CFormTextarea, CFormSelect, CInputGroup, CInputGroupText,
	CTooltip,
	CLink,
	CImage,
	CCard, CCardHeader, CCardBody,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import { MyButton } from './index';
import { UFunc } from "../helpers/functions";
import PropTypes from 'prop-types';
import {
	MyDialoglookup,
} from '../components/index'

const pjson 	= require('../../package.json')
const MyDialogformantrian = props => {	
	const {
		show,toggle,onSimpan,showToast,prosesExpired,setSessionaktif,setLoading,
		...rest
	} = props;

	const uDispatch 		= useDispatch();

	const uBahasaObj  		= useSelector(state => state.listBahasa);
	const uTokenObj			= JSON.parse(localStorage.getItem("token")||"{}");
	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uCabangIDuser		= parseInt(uTokenObj.user_cabangid)||0;
	const uCabangselectedObj 				= useSelector(state => state.gCabangatribut) || {};
	const [uCabanginitObj,setCabanginitObj] = React.useState(uCabangselectedObj);

	const uFieldformObj						= JSON.parse(useSelector(state => state.gFormantrianstr) || "{}");
	const [uDatadokterArr,setDatadokterArr]	= React.useState([]);
	const [uFormdataObj,setFormdataObj]  	= React.useState({});

	//--CEK_ANTRIAN--/
	const [uCekantrianshow,setCekantrianshow] = React.useState(false);
	const [uCekantrianObj,setCekantrianObj] = React.useState({});
	const uCekDataantrianArr				= uCekantrianObj.antrian_arr || [];
	//--END CEK_ANTRIAN--/

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//---END DLG_LOOKUP--/

	const hdlKDownDocument = (_EV) => {
		if(_EV.keyCode === 27) {
			if(uCekantrianshow) {
				_EV.preventDefault();
				_EV.stopPropagation();

				setCekantrianshow(false);
			}
			return;
		}
	}
	const hdlKDowndoktercaption = (_EV) => {
		uFormdataObj.dokter_id = ("0")
		if(_EV.keyCode !== 13)  return;
		if(uFormdataObj.dokter_caption.trim() === "") return;

		_EV.preventDefault()
		_EV.stopPropagation()

		const vElfocus = document.getElementById("inpjamawal");
		const vfilterArr = uDatadokterArr.filter(vItems => 
			vItems.dokter_caption.toUpperCase().includes(uFormdataObj.dokter_caption.trim().toUpperCase())
		)

		if(vfilterArr.length === 1) {
			uFormdataObj.dokter_id = (vfilterArr[0].id||"0")
			uFormdataObj.dokter_caption = (vfilterArr[0].dokter_caption||"")
			vElfocus && vElfocus.focus();
			return
		}

		hdlKlikLookupdokter()
		return;
	}
	const hdlKlikLookupdokter = () => {
		const vDatalookupArr = uDatadokterArr.map(vItems =>{ 
			return {id: vItems.id,caption:vItems.dokter_caption} 
		})

		setDlglookupObj({...uDlglookupObj,
			dlg_header: (uBahasaObj.word_lookup||"Lookup")+": "+(uBahasaObj.caption_datadokter||"Data Dokter"),
			dlg_input: "",
			data_arr: vDatalookupArr,
		})

		/*setFormdataObj({...uFormdataObj,
			dokter_caption: "",
			dokter_id: 0,
		})//-*/

		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return

		setDlglookupshow(false);
		const vArridx 	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM)

		setFormdataObj({...uFormdataObj,
			dokter_caption: (uDatadokterArr[vArridx].dokter_caption||""),
			dokter_id: (uDatadokterArr[vArridx].id||"0"),
		})

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout)

			const vElfocus = document.getElementById("inpjamawal");
			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikCekantriantoggle = () => {//--TIDAK_DIPAKAI--/
		if(!uCekantrianshow) {
			if((uFormdataObj.tgl_antri||"")==="") {
				showToast("Harap Tentukan Tanggal Antrian Terlebih Dahulu !");
				return;
			}
			if(uFormdataObj.tgl_antri === UFunc.DbDate()) {
				showToast("Tanggal Cek Antrian Hanya Untuk Tanggal SETELAH Hari Ini !");
				return;	
			}
			const vTglantriDT = UFunc.toDate(uFormdataObj.tgl_antri);
			if(UFunc.DateIsMundur(vTglantriDT)) {
				showToast("Tanggal Cek Antrian Sudah Kadaluwarsa !");
				return;	
			}
		}
		setCekantrianshow(!uCekantrianshow);
	}
	const hdlKlikCekantrianview = () => {
		if((uCekantrianObj.tgl_antri||uFormdataObj.tgl_antri)==="") {
			setCekantrianObj({...uCekantrianObj, errormsg:"Harap Tentukan Tanggal Antrian Terlebih Dahulu !"});
			return;
		}
		if(uCekantrianObj.tgl_antri === UFunc.DbDate()) {
			setCekantrianObj({...uCekantrianObj, errormsg:"Tanggal Cek Antrian Hanya Untuk Tanggal SETELAH Hari Ini !"});
			return;
		}
		const vTglantriDT = UFunc.toDate(uCekantrianObj.tgl_antri);
		if(UFunc.DateIsMundur(vTglantriDT)) {
			setCekantrianObj({...uCekantrianObj,
				errormsg:"Tanggal Cek Antrian Sudah Kadaluwarsa !",
			});
			return;
		}

		apiLoadantrian();
	}
	const hdlKlikSimpan = () => {
		//-VALIDASI--/
		let vElfocus = document.getElementById("inptglantri");
		if(uFormdataObj.tgl_antri === "") {
			vElfocus && vElfocus.focus()
			showToast("Tgl Antrian Tidak Valid !"); return
		}
		const vTglantriDT = UFunc.toDate(uFormdataObj.tgl_antri);
		if(UFunc.DateIsMundur(vTglantriDT)) {
			vElfocus && vElfocus.focus()
			showToast("Tgl Antrian Sudah Kadaluwarsa !"); return
		}

		if(parseInt(uFormdataObj.dokter_id) > 0) {
			vElfocus = document.getElementById("inpjamawal");
			if((uFormdataObj.jam_awal||"") === "") {
				vElfocus && vElfocus.focus();
				showToast("Jenis Antrian Merupakan Antrian JANJIAN.."+
					"<br/>Jam Janjian AWAL Harus Diisi !"+
					""); return;
			}

			vElfocus = document.getElementById("inpjamakhir");
			if((uFormdataObj.jam_akhir||"") === "") {
				vElfocus && vElfocus.focus();
				showToast("Jenis Antrian Merupakan Antrian JANJIAN.."+
					"<br/>Jam Janjian AKHIR Harus Diisi !"+
					""); return
			}

			const vTimeAwalDT	= UFunc.toDatetime(uFormdataObj.tgl_antri+" "+uFormdataObj.jam_awal+":00");
			const vTimeAkhirDT	= UFunc.toDatetime(uFormdataObj.tgl_antri+" "+uFormdataObj.jam_akhir+":00");

			if(vTimeAwalDT.valueOf() === vTimeAkhirDT.valueOf()) {
				vElfocus && vElfocus.focus();
				showToast("Selisih Jam Janjian AWAL dan AKHIR Tidak Valid !"); return
			}
			if(vTimeAwalDT.valueOf() > vTimeAkhirDT.valueOf()) {
				vElfocus && vElfocus.focus();
				showToast("Jam Janjian AWAL Lebih Besar dari Jam Janjian AKHIR !"); return
			}

			vElfocus = document.getElementById("inpnoruang");
			if((parseInt(uFormdataObj.no_ruang)||0) <= 0
				|| (parseInt(uFormdataObj.no_ruang)||0) > (parseInt(uCabanginitObj.jml_ruangan)||2)) {
				vElfocus && vElfocus.focus();
				showToast("No Ruangan Tidak Valid !"); return
			}
		}
		//-END VALIDASI--/

		onSimpan();
	}

	const contentForm = () => {
		if(!show) return;

		const vTglnowDT 	= UFunc.toDate(UFunc.DbDate());
		const vTglantriDT	= UFunc.toDate(uFormdataObj.tgl_antri);

		let vArrstatusrsvp 	= [
			{value:"BOOKED",label:"BOOKING BIASA"},
			{value:"CONFIRMED",label:"TERKONFIRMASI"},
		];

		if((uFormdataObj.init_modul||"").toUpperCase() === "DAFTARANTRI")
			if(vTglnowDT.valueOf() === vTglantriDT.valueOf()
				&& (parseInt(uFormdataObj.dokter_id)||0) > 0
				) vArrstatusrsvp.push({value:"HADIR",label:"SUDAH HADIR"});

		return (
		<CForm className="mx-lg-3">
		<div className="p-3 border rounded bg-light classpetunjuk">
			*) {UFunc.renderHTML(uBahasaObj.petunjuk_daftarantri||"Masukkan Data-data Pendaftaran Pemeriksaan pada form di bawah ini, kemudian tekan SIMPAN.")}
			<br/>
			<br/>Untuk Reservasi UMUM, KOSONGI Nama Dokter dan Jam Janjian,
			<br/>Untuk Reservasi JANJIAN, Nama Dokter dan Jam Janjian HARUS DIISI..
		</div>

		{uDatacabangArr.length > 1 && (
		<CRow className="my-3">
		<CCol xs="4" className="text-md-end">{uBahasaObj.word_cabang||"Cabang"}</CCol>
		<CCol xs="8" className="text-end text-md-start text-primary">
			<CFormSelect size="sm"
				value={uFormdataObj.id_cabang}
				onChange={(e)=>setFormdataObj({...uFormdataObj,id_cabang:e.target.value})}
				id="inpformcabangid">
			{uDatacabangArr.map((vItems,vKeys)=>{
				return (
				<option key={vKeys} value={vItems.id}>{(vItems.cabang_nama||"").toUpperCase()}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>
		)}

		<CRow className="my-2">
		<CCol xs="4" className="text-md-end fw-bold">{uBahasaObj.caption_tglantri||"Tgl Reservasi"}</CCol>
		<CCol xs="8" lg="4" className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_antri||""}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_antri:e.target.value})}
				id="inptglantri"/>

			<span className="me-2"/>

			<CInputGroupText className="bg-transparent py-0">
			<CTooltip className="d-none d-lg-block" content="--Cek TANGGAL ANTRIAN dulu..">
			<CLink className="classcursorpointer" onClick={()=>hdlKlikCekantriantoggle()}>
			<CImage src={pjson.homepage+"api\/images\/menus_antrianpasien.png"} height={23}/>
			</CLink>
			</CTooltip>
			</CInputGroupText>
			</CInputGroup>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="4" className="text-md-end text-success">
			<small className="d-md-none">{uBahasaObj.caption_pilihdokter||"Dokter Janjian"}</small>
			<span className="d-none d-md-block">{uBahasaObj.caption_pilihdokter||"Dokter Janjian"}</span>
		</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" 
				value={uFormdataObj.dokter_caption||""}
				onChange={(e)=>setFormdataObj({...uFormdataObj,dokter_caption:e.target.value})}
				onKeyDown={(e)=>hdlKDowndoktercaption(e)}
				id="inpdoktercaption"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikLookupdokter()}
				id="btndokterpilih">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="text-md-end text-success">
			<small className="d-md-none">{uBahasaObj.caption_jamjanjian||"Jam Janjian"}</small>
			<span className="d-none d-md-block">{uBahasaObj.caption_jamjanjian||"Jam Janjian"}</span>
		</CCol>
		<CCol xs="8" lg="4" className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="time"
				min="07:00" max="22:00" 
				value={uFormdataObj.jam_awal||""}
				onChange={(e)=>setFormdataObj({...uFormdataObj,jam_awal:e.target.value})}
				id="inpjamawal"/>
			<CInputGroupText className="py-0">s.d.</CInputGroupText>
			<CFormInput size="sm" type="time"
				min="07:00" max="22:00" 
				value={uFormdataObj.jam_akhir||""}
				onChange={(e)=>setFormdataObj({...uFormdataObj,jam_akhir:e.target.value})}
				id="inpjamakhir"/>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="text-md-end text-success">
			<small className="d-md-none">{uBahasaObj.caption_pilihruang||"Pilih Ruangan"}</small>
			<span className="d-none d-md-block">{uBahasaObj.caption_pilihruang||"Pilih Ruangan"}</span>
		</CCol>
		<CCol xs="8" lg="4" className="text-end">
			<CFormSelect size="sm"
				value={uFormdataObj.no_ruang}
				onChange={(e)=>setFormdataObj({...uFormdataObj,no_ruang:e.target.value})}
				id="inpnoruang">
				{(() => {
					 let vOption = [];
					 for (let i = 1; i <= (parseInt(uCabanginitObj.jml_ruangan)||2); i++) {
					 	vOption.push(<option value={i} key={i}>Ruang No-{i}</option>);
					 }
					 return vOption;
				})()}
			</CFormSelect>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="4" className="text-md-end">{uBahasaObj.caption_ketantrian||"Ket.Antrian"}</CCol>
		<CCol className="text-end">
			<CFormInput size="sm" maxLength={255}
				value={uFormdataObj.keterangan}
				onChange={(e)=>setFormdataObj({...uFormdataObj,keterangan:e.target.value})}
				onKeyDown={(e)=>{
					const vElkehadiran = document.getElementById("inpstatusrsvp")
					if(vElkehadiran.disabled===true || (vElkehadiran.offsetParent === null))
						UFunc.hdlKeyDownInput(e,"btnDialogSimpan")
				}}
				id="inpketantri"/>
		</CCol>
		</CRow>

		<CRow className={"my-2"+((parseInt(uFormdataObj.id)||0) > 0 ? " d-none" :"")}>
		<CCol xs="4" className="text-md-end">{uBahasaObj.caption_statusrxvp||"Status RSVP"}</CCol>
		<CCol xs="8" lg="4" className="text-end">
			<CFormSelect size="sm"
				value={uFormdataObj.status_rsvp}
				onChange={(e)=>setFormdataObj({...uFormdataObj,status_rsvp:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpstatusrsvp">
			{vArrstatusrsvp.map((vItems,vKeys)=>{
				return (
					<option value={vItems.value} key={vKeys}>{vItems.label}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentFloatantrian = () => {
		if(!show) return (<></>)//>
		if(!uCekantrianshow) return (<></>)//>

		return (
		<>
		<div 
			style={{
				position:"fixed",
				top:"1%",right:"1%",
				minWidth:300,
				width:"35%",
				zIndex:1091,
				backgroundColor:"#AEAEAE99",
				border:"1px dotted gray",
				borderRadius:10,
			}}
			className="d-none d-lg-block"
			id="idshowantrian">
			{contentShowantrian()}
		</div>

		<div 
			style={{
				position:"fixed",
				top:"1%",right:"1%",
				minWidth:300,
				width:"50%",
				zIndex:1091,
				backgroundColor:"#AEAEAE99",
				border:"1px dotted gray",
				borderRadius:10,
			}}
			className="d-none d-md-block d-lg-none"
			id="idshowantrian">
			{contentShowantrian()}
		</div>

		<div 
			style={{
				position:"fixed",
				top:"1%",right:"1%",
				minWidth:300,
				width:"98%",
				zIndex:1091,
				backgroundColor:"#AEAEAE",
				border:"1px dotted gray",
				borderRadius:10,
			}}
			className="d-md-none"
			id="idshowantrian">
			{contentShowantrian()}
		</div>
		</>
		)//->
	}
	const contentShowantrian = () => {
		if(!uCekantrianshow) return "";

		//--> [{"dokter_id":"99","dokter_caption":"AGNES ENDRA, SpPros, DRG","pasien_id":"43371","pasien_caption":"Andy","pasien_telp":null,"jam_awal":"11:15:00","jam_hadir":null,"no_urut":"0","keterangan":"Ini Ketarangan Antrian","id":"26"}]
		const vAntrianjanjianArr= uCekDataantrianArr.filter(vItems=>parseInt(vItems.no_urut)<=0);
		const vAntrianumumArr 	= uCekDataantrianArr.filter(vItems=>parseInt(vItems.no_urut)>0);

		const vPasienID			= parseInt(uFormdataObj.id_pasien)||0;

		return (
		<div className="position-relative" style={{
			padding:15,
			minHeight:window.innerHeight-50,
			height:window.innerHeight-20,
			}}>
			<div style={{position:"absolute",top:-1,left:-1,zIndex:10}}>
			<CButton size="sm" color="transparent" className="p-1 fw-bolder classcursorpointer"
				onClick={()=>setCekantrianshow(false)}
				id="btncekantriclose">
			<CIcon icon="cilXCircle" className="text-danger" height={30}/>
			</CButton>
			</div>
		<CCard className="classbgcard w-100 h-100">
		<CCardHeader className="text-center">
			<small className="fw-bolder">CEK Antrian Pasien</small>
			<div className="classborderbottom my-2"/>
			<CForm className="mx-3">
			<CInputGroup size="sm">
				{uDatacabangArr.length > 1 && (
				<CFormSelect size="sm"
					value={uCekantrianObj.id_cabang||uFormdataObj.id_cabang}
					onChange={(e)=>setCekantrianObj({...uCekantrianObj,id_cabang:e.target.value})}
					id="inpcekcabangid">
				{uDatacabangArr.map((vItems,vKeys)=>{
					return (
					<option value={vItems.id} key={vKeys}>{vItems.cabang_nama}</option>
					)
				})}
				</CFormSelect>
				)}
				<CFormInput size="sm" type="date"
					value={uCekantrianObj.tgl_antri || uFormdataObj.tgl_antri}
					onChange={(e)=>setCekantrianObj({...uCekantrianObj,tgl_antri:e.target.value})}
					id="inpcektglantri"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikCekantrianview()}
					id="btncekantri">
					<CIcon icon="cilMagnifyingGlass"/>
				</CButton>
			</CInputGroup>
			</CForm>
		</CCardHeader>
		<CCardBody style={{ overflowY:"auto",}}>
			{(uCekantrianObj.isLoading||false)==true ? (
				<center><CSpinner className="mx-auto" color="blue"/></center>
			) : (
			<>
			{(uCekantrianObj.errormsg||"")!=="" ? (
				<div className="classfontsmaller text-center">{UFunc.renderHTML(uCekantrianObj.errormsg)}</div>
			) : (
				<small>
				{vAntrianjanjianArr.length > 0 && (
				<>
				<div className="px-2 mb-1 fw-bolder text-white" 
					style={{backgroundColor:"#666699"}}>Antrian Janjian</div>
				{vAntrianjanjianArr.map((vItems,vKeys)=>{
					const {
						dokter_id,dokter_caption,pasien_id,pasien_caption,jam_awal,no_urut,keterangan
					} = vItems;

					const vListyle	= {
						borderBottom: "1px dotted black"
					}
					if(parseInt(pasien_id)===parseInt(vPasienID))
						vListyle.backgroundColor = "#FF510044";

					return (
					<div style={vListyle} key={vKeys}>
					<CRow className="mx-0 pb-1">
						<CCol md="1" className="px-0 text-end">{vKeys+1}.</CCol>
						<CCol md="9">
							<div><b>{vItems.pasien_caption}</b></div>
							<small className="text-primary classfontsmaller fst-italic">{vItems.dokter_caption}</small>
						</CCol>
						<CCol md="2" className="px-0 text-center">
							<b>{(vItems.jam_awal||"").substring(0,5)}</b>
						</CCol>
					</CRow>
					</div>
					)
				})}
				</>
				)}

				{vAntrianumumArr.length > 0 && (
				<>
				<div className="px-2 mb-1 fw-bolder text-white" 
					style={{backgroundColor:"#993366"}}>Antrian Umum</div>
				{vAntrianumumArr.map((vItems,vKeys)=>{
					const {
						dokter_id,dokter_caption,pasien_id,pasien_caption,jam_awal,no_urut,keterangan
					} = vItems;

					const vListyle	= {
						borderBottom: "1px dotted black"
					}
					if(parseInt(pasien_id)===parseInt(vPasienID))
						vListyle.backgroundColor = "#FF510044";

					return (
					<div style={vListyle} key={vKeys}>
					<CRow className="mx-0 pb-1">
						<CCol md="1" className="px-0 text-end">{vKeys+1}.</CCol>
						<CCol md="9">
							<div><b>{vItems.pasien_caption}</b></div>
						</CCol>
						<CCol md="2" className="px-0 text-center">
							No-<b>{(vItems.no_urut)}</b>
						</CCol>
					</CRow>
					</div>
					)
				})}
				</>
				)}
				</small>
			)}
			</>
			)}
		</CCardBody>
		</CCard>
		</div>
		)//>
	}

	const apiLoadinit = () => {
		/*//--TESTING_FRONTEND--/
		console.log("(Daftarantri - apiLoadawal) LEWAT ");
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_dokter/ld_dokterlookup";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){ setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.tampil) {
				setDatadokterArr(JSON.parse(output_string.datadokter||"[]"))
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogformantrian - apiLoadinit) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				prosesExpired(); return;
			}
		})
		.catch((error) =>{
			console.log("(MyDialogformantrian - apiLoadinit) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadantrian = () => {//--TIDAK_DIPAKAI--/
		setCekantrianObj({...uCekantrianObj,
			errormsg: "",
			isLoading: true,
		});

		const vDATAS	= JSON.stringify({
			send_cabangid : uCekantrianObj.id_cabang||uFormdataObj.id_cabang,
			send_tglantri : uCekantrianObj.tgl_antri||uFormdataObj.tgl_antri,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_antrian/ld_data";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.tampil) {
				const vTmpArr =  JSON.parse(output_string.dataobject || "[]");

				setCekantrianObj({...uCekantrianObj,
					antrian_arr: vTmpArr,
					errormsg: (vTmpArr.length <= 0 ? "<div class='classpetunjuk'>&middot; Data Antrian Tidak Ada &middot;</div>" : undefined),
				});
			} else if(output_string.info) {
				setCekantrianObj({...uCekantrianObj,
					errormsg: output_string.info,
					isLoading: false,
				});
			} else if(output_string.errors) {
				console.log("(MyDialogformantrian - apiLoadantrian) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setCekantrianObj({...uCekantrianObj,
					errormsg: "<font color='red'>"+vMsg+"</font>",
					isLoading: false,
				});
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setCekantrianObj({...uCekantrianObj,
				errormsg: "<font color='red'>"+(pjson.mydefault.msg500str.join(" "))+"</font>",
				isLoading: false,
			});
			console.log("(MyDialogformantrian - apiLoadantrian) catch-error : "+error);
		});
	}

	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		apiLoadinit();

    	return () => {
    		uDispatch({type: "set", gFormantrianstr: undefined});
    		setDatadokterArr([]);
    	}
	},[])
	React.useEffect(()=>{
		if(!show) return;

		//console.log("(MyDialogformantrian - [show]) uFieldformObj = "+JSON.stringify(uFieldformObj));
		setFormdataObj(uFieldformObj);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(!isMobile) {
				document.getElementById("inpformcabangid") &&
					document.getElementById("inpformcabangid").focus();
			}
		},350);

    	return () => { setFormdataObj({}); }
	},[show]);
	React.useEffect(()=>{
		//console.log("(MyDialogformantrian - [uFormdataObj]) uFormdataObj => "+JSON.stringify(uFormdataObj));
		if(!show) return;

    	uDispatch({type: "set", gFormantrianstr: JSON.stringify(uFormdataObj)});
	},[uFormdataObj]);
	React.useEffect(()=>{
		if(!show) return;

		if(uFormdataObj.id_cabang === undefined) {
			const vArridx = UFunc.getObjectIndeks(uDatacabangArr,uCabangIDuser);
			setFormdataObj({...uFormdataObj,
				id_cabang:uCabangIDuser,
				//cabang_caption: (uDatacabangArr[vArridx]||{}).cabang_nama||"Undf Cabang"
			});
			return;
		}
		if(uFormdataObj.tgl_antri === undefined) {
			setFormdataObj({...uFormdataObj,tgl_antri:UFunc.DbDate()})
			return;
		}
		if(uFormdataObj.status_rsvp === undefined) {
			setFormdataObj({...uFormdataObj,status_rsvp:"BOOKED"})
			return;
		}
		if(uFormdataObj.no_ruang === undefined) {
			//console.log("(MyDialogformantrian - [no_ruang]) LEWAT ");
			setFormdataObj({...uFormdataObj,no_ruang:1})
			return;
		}
	},[uFormdataObj,
	uFormdataObj.id_cabang,
	uFormdataObj.tgl_antri,
	uFormdataObj.no_ruang,
	uFormdataObj.status_rsvp,
	]);
	React.useEffect(()=>{
		if(!uISDlglookupshow) {
			setDlglookupObj({}); return;
		}
	},[uISDlglookupshow])
	React.useEffect(()=>{
		if(!uCekantrianshow) 
			{ setCekantrianObj({}); return }

		apiLoadantrian();

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			document.getElementById("btncekantriclose") &&
				document.getElementById("btncekantriclose").focus();
		},350)
	},[uCekantrianshow])
	React.useEffect(()=>{
		setCekantrianObj({...uCekantrianObj,antrian_arr: []});
	},[uCekantrianObj.tgl_antri,uCekantrianObj.id_cabang])

	return (
		<>
		{contentFloatantrian()}
		<CModal size="lg" alignment="center" visible={show} scrollable {...rest}>
		<CModalHeader 
			className="bg-light text-dark py-2"
			closeButton={false}>
			<CModalTitle>
				{(uFormdataObj.idxkey || uFormdataObj.id) ? (
				<>
				<div className="d-none d-md-block">Edit Reservasi</div>
				<small className="d-md-none">Edit Reservasi</small>
				</>
				) : (
				<>
				<div className="d-none d-md-block">Form Pendaftaran Reservasi</div>
				<small className="d-md-none">Form Pendaftaran Reservasi</small>
				</>
				)}
			</CModalTitle>
			<CCloseButton onClick={toggle}/>
		</CModalHeader>

		<CModalBody className="px-lg-5">{contentForm()}</CModalBody>

		<CModalFooter>
		<MyButton onClick={()=>hdlKlikSimpan()}
			id="btnDialogSimpan">
			<CIcon icon="cilCheckAlt" className="me-1" />
			{uBahasaObj.word_simpan||"Simpan"}
		</MyButton>
		<span className="me-1"/>
		<CButton color="light" onClick={toggle}>{uBahasaObj.word_batal||"Batal"}</CButton>
		</CModalFooter>
		</CModal>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.dlg_input}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"/>
		</>
	)//>
}
MyDialogformantrian.defaultProps = {
	show: false,
};
MyDialogformantrian.propTypes = {
	show: PropTypes.bool,            
	toggle: PropTypes.func,      
	onSimpan: PropTypes.func,
}

export default MyDialogformantrian;